'use client'

import { FC, useRef } from 'react'
import { AriaTabPanelProps, useTabPanel } from 'react-aria'
import { TabListState } from 'react-stately'

interface TabPanelProps extends AriaTabPanelProps {
  state: TabListState<object>
}

export const TabPanel: FC<TabPanelProps> = ({ state, ...props }) => {
  const ref = useRef(null)
  const { tabPanelProps } = useTabPanel(props, state, ref)
  return (
    <div {...tabPanelProps} ref={ref}>
      {state.selectedItem?.props.children}
    </div>
  )
}
